module.exports = __webpack_public_path__ + "static/marketing-6ec1d3096de714d8ad1a35d3bee912f8.jpg";